// extracted by mini-css-extract-plugin
export default {"timerBox":"timer_timerBox__uE10L","timer":"timer_timer__WML+0"};